export default "__VITE_ASSET__DduPdT$j__"